import { useAppStore } from "@store/appStateStore";
import Container from "../../../shared/Container";
import Card from "../../../shared/Card";
import AddAttendanceForParticipantsForm from "../../../form/attendance/AddAttendanceForParticipantsForm";
import UpdateAttendanceAmountsForm from "../../../form/attendance/UpdateAttendanceAmountsForm";
import AttendancesTable from "../../../stat/attendance/table/AttendancesTable";
import Calendar from "@components/shared/Calendar";

const AttendancesTab: React.FC = () => {
  const { participant, attendances, directions } = useAppStore();

  const customAttendances = participant
    ? attendances.filter((a) => a.participant_id === participant)
    : (attendances ?? []);

  const getTooltipContent = (date: any) => {
    const attendancesAtDate = customAttendances.filter((a) => a.date === date);
    var dirs: Record<
      number,
      { dirName: string; totalAmount: number; count: number }
    > = {};

    attendancesAtDate.forEach((a) => {
      if (!dirs?.[a.direction_id]) {
        const dirName =
          directions.find((d) => d.id === a.direction_id)?.name ?? "Не указано";
        dirs[a.direction_id] = { totalAmount: 0, count: 0, dirName: dirName };
      }
      dirs[a.direction_id].count += 1;
      dirs[a.direction_id].totalAmount += a.amount;
    });

    return Object.entries(dirs).map(([_, data]) => (
      <p>{`${data.dirName}: ${data.count} (${data.totalAmount}р.)`}</p>
    ));
  };

  return (
    <Container title="Управление посещениями">
      <Card title="Добавить посещение для группы">
        <AddAttendanceForParticipantsForm hasAmount hasIsPaid />
      </Card>
      <Card width="half">
        <AttendancesTable hasAmount hasIsPaid />
      </Card>

      <Card title="Коррекция стоимости занятий" width="quarter">
        <UpdateAttendanceAmountsForm />
      </Card>
      <Card>
        <Calendar
          selectedDates={customAttendances.map((a) => {
            return { date: a.date, direction: a.direction_id };
          })}
          onDateRemove={() => {}}
          onDateSelect={() => {}}
          dateSectionSow={false}
          getTooltipContent={getTooltipContent}
        />
      </Card>
    </Container>
  );
};

export default AttendancesTab;
